const SYMBOL_BY_CURRENCY: Record<string, string> = {
  KES: "KSh",
  USD: "$",
  EUR: "€",
  GBP: "£",
};

export function formatMoney(cents: number, currency = "KES"): string {
  const symbol = SYMBOL_BY_CURRENCY[currency] ?? currency;
  const amount = cents / 100;
  const formatted = amount.toLocaleString("en-KE", {
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return `${symbol} ${formatted}`;
}
